import React, { useEffect, useRef, useState} from 'react';
import {
    Box,
    Button,
    CircularProgress,
    Container,
    Modal,
    Paper,
    Typography
} from "@material-ui/core";
import {Alert} from "@material-ui/lab";
import useStyles from "../../styles/styles";
import useFormInputs from "../../hooks/useFormInputs";
import SignatureBlockFields from "./SignatureBlockFields";
import {getIsPair} from "../../utils/signatureBlockUtils";

const SignatureBlockPairModal = ({ data, modalData, closeModal, setFinalValue}) => {
    const classes = useStyles();
    const [match, setMatch] = useState([]);
    const [errors, setErrors] = useState([]);
    const [firstInputBlockValue, setFirstInputBlockValue] = useState(null);
    const [secondInputBlockValue, setSecondInputBlockValue] = useState(null);
    // const textAreaRef = useRef(null);
    const [submitLoading, setSubmitLoading] = useState(false);
    const [modalTitle, setModalTitle] = useState('');
    const onSubmit = () => {
        setSubmitLoading(true);
        setErrors([]);
        let inputError = false;
        const { firstBlockValue, secondBlockValue, filterField, expires, overrideExisting, blockReason } = inputs;
        const newData = {
            firstBlockValue,
            secondBlockValue,
            filterField,
            expires,
            overrideExisting,
            blockReason
        };

        if(newData.expires === '') {
            newData.expires = null
        }

        Object.keys(newData).forEach(key => {
            const value = newData[key]
            if (value === '') {
                inputError = true
            }
        });

        if (modalData.data.id) {
            newData.id = modalData.data.id;
        }
        if (!inputError) {
            if (modalData.showAddRow) {
                modalData.triggerCreate(firstBlockValue, secondBlockValue, newData, blockReason);
            } else {
                modalData.triggerUpdate(firstBlockValue, secondBlockValue, newData, blockReason);
            }
        } else {
            setSubmitLoading(false);
            setErrors(['error']);
        }
    };
    const {inputs, handleSubmit, setInputs} = useFormInputs(onSubmit);

    useEffect(() => {
        if (modalData) {
            if (modalData.blockValue) {
                const split = modalData.blockValue.split('-')
                const second = split.slice(1, split.length - 1).join('-')
                setFirstInputBlockValue(split.first());
                setSecondInputBlockValue(second);
            }
            setInputs(inputs => ({
                ...inputs,
                firstBlockValue: firstInputBlockValue || '',
                secondBlockValue: secondInputBlockValue || '',
                filterField: modalData.data.filterField || '',
                blockReason: modalData.data.blockReason || '',
                expires: modalData.data.expires || '',
                overrideExisting: modalData.overrideExisting || false
            }));
            data.filterFields = {
                enumValues: [
                    {
                        name: 'BANK_ROUTING_BANK_ACCOUNT_HASH'
                    }, {
                        name: 'LEGAL_ID_STATE_LEGAL_ID_HASH'
                    }, {
                        name: 'BANKROUTING_TSID'
                    }, {
                        name: 'BANKROUTING_AFFILIATE_KEY'
                    }, {
                        name: 'STATE_TSID_IPQS'
                    }, {
                        name: 'STATE_TSID_FULL'
                    }, {
                        name: 'AFFILIATE_KEY_SUB_CODE'
                    }, {
                        name: 'REFERRING_SITE_URL_TSID'
                    }, {
                        name: 'REFERRING_SITE_URL_AFFILIATE_KEY'
                    }
                ],
            };

            resetTypes();
            getModalTitle(modalData.filterField);
        }
    }, []);

    useEffect(() => {
        if (inputs) {
            if (inputs.filterField) {
                modalData.filterField = inputs.filterField;
            }

            if (inputs.filterField) {
                modalData.isPair = getIsPair(inputs.filterField)
            }

            modalData.isPair = inputs.overrideExisting || false

            getModalTitle(inputs.filterField);
            resetTypes();
        }
    }, [inputs]);

    useEffect(() => {

            triggerList();
            //Set Height Match Height
            // setHeight(textAreaRef.current.clientHeight);

    }, [firstInputBlockValue]);

    const resetTypes = () => {

    };

    const triggerList = () => {
        const filterField = modalData.filterField;
        let match

        if(modalData.filterField && modalData.filterField.includes('AFF')) {
            match = checkMatches('Affiliate', data.allAffiliate.nodes, firstInputBlockValue);
        } else if(modalData.filterField && modalData.filterField.includes('TSID')) {
            match = checkMatches('Traffic Source', data.allTrafficSource.nodes, firstInputBlockValue);
        } else {
            match = true
        }

        getModalTitle(filterField);
        setMatch(match);
    };

    const getModalTitle = (name) => {
        let title;
        switch (name) {
            case 'BANKROUTING':
                title = 'Bank Routing';
                break;
            case 'BANK_ROUTING_BANK_ACCOUNT_HASH':
                title = 'Bank Info';
                break;
            case 'PRIMARYEMAIL':
                title = 'Primary Email';
                break;
            case 'BANKROUTING_TSID':
                title = 'Bank Routing - Traffic Source Id';
                break;
            case 'BANKROUTING_AFFILIATE_KEY':
                title = 'Bank Routing - Affiliate Key';
                break;
            case 'STATE_TSID_IPQS':
                title = 'Home State - Traffic Source Id + IP quality score';
                break;
            case 'STATE_TSID_FULL':
                title = 'Home State - Traffic Source Id';
                break;
            case 'MOBILEPHONE':
                title = 'Mobile Phone';
                break;
            case 'HOMEPHONE':
                title = 'Home Phone';
                break;
            case 'WORKPHONE':
                title = 'Work Phone';
                break;
            case 'SSN_HASH':
                title = 'Ssn Hash';
                break;
            case 'REFERRING_SITE_URL':
                title = 'Referring Site url';
                break;
            case 'CLIENTIP':
                title = 'Client IP';
                break;
            case 'REFERRING_SITE_URL_TSID':
                title = 'Referring Site url - Traffic Source Id';
                break;
            case 'REFERRING_SITE_URL_AFFILIATE_KEY':
                title = 'Referring Site url - Affiliate Key';
                break;
            default:
                title = 'Signature Block'
                break;
        }
        if (title) {
            setModalTitle(title);
        }
    };

    /**
     * Checks for matches from what is entered
     * @param type
     * @param nodes
     * @param item
     * @returns Object
     */
    const checkMatches = (type, nodes, item) => {
        let isMatch = [];
        const pair = item.indexOf(',') ? item.replace(/,/,'&').split('&') : '';
        isMatch = nodes.filter(node => {
            const id = node.id.toLowerCase();

            if (pair[1].length) {
                return id === pair[1].toLowerCase() || node.key === pair[1];
            }

            if (type === 'Traffic Source') {
                return id === item.toLowerCase();
            }

            return id === item.toLowerCase() || node.key.toLowerCase() === item.toLowerCase();
        });
        if (isMatch.length) {
            const match = isMatch[0];

            return {
                type,
                firstValue: match.id,
                error: false,
                source: match,
                secondValue: pair[1] ? pair[1] : '',
            }
            } else {
                return {
                    type,
                    error: true,
                    firstValue: item,
                    source: item,
                    secondValue: pair[1],
                };
            }
    };

    return (
        <Modal
            open={true}
            onClose={closeModal}
        >
            <Container className={classes.modal} maxWidth={false}>
                <Paper className={classes.paper} style={{marginBottom: 0, overflow: 'hidden'}}>
                    <Typography variant="h5" align="center" gutterBottom>
                        Please add your signature block.
                    </Typography>
                    {errors.includes('error') ? (
                        <Alert severity="error" style={{ marginBottom: '10px'}}>Please add values to the highlighted fields!</Alert>
                    ) : false}
                    <SignatureBlockFields
                        inputs={inputs}
                        setInputs={setInputs}
                        data={data}
                        modalData={modalData}
                        defaultCategory={'categories'}
                    />
                    <Box
                        display={"flex"}
                        alignItems={"center"}
                        style={{margin: '10px 0'}}
                        justifyContent={"center"}>
                        <Box style={{marginRight: '10px'}}>
                            <Button
                                variant="contained"
                                color="primary"
                                disabled={submitLoading || !match}
                                onClick={() => {
                                    handleSubmit();
                                }}
                            >
                                {submitLoading ? (
                                    <CircularProgress color="inherit"/>
                                ) : (
                                    <>
                                        Save Values
                                    </>
                                )}
                            </Button>
                        </Box>
                        <Box>
                            <Button
                                variant="contained"
                                color="secondary"
                                onClick={() => {
                                    closeModal();
                                }}
                            >
                                Cancel
                            </Button>
                        </Box>
                    </Box>
                </Paper>
            </Container>
        </Modal>
    );
};

export default SignatureBlockPairModal;
